import React from 'react';
import { configure } from 'axios-hooks';

const QueryConfigure = ({ axios, cache, children }: any) => {
  configure({ axios, cache });

  return children;
};

export default QueryConfigure;
